import useDictateContext from '/druid/internal/useDictateContext';

export default function useReadyState() {
  const { readyState } = useDictateContext();

  return [readyState];
}
